import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/toggle-button/toggle-button.component.js'

const tagName = 'dap-ds-toggle-button'

/**
 * `dap-ds-toggle-button` is a custom toggle button component.
 * @element dap-ds-toggle-button
 * @summary A toggle button is a button that can be toggled on (active) or off (inactive).
 * @title - Toggle button
 *
 * @slot - The content of the toggle button.
 *
 * @csspart base - The main button container.
 * @csspart high-contrast - The high contrast part of the button.
 *
 * @cssproperty --dds-toggle-button-min-width-lg - Minimum width of the large toggle button
 * @cssproperty --dds-toggle-button-min-width-md - Minimum width of the medium toggle button
 * @cssproperty --dds-toggle-button-min-width-sm - Minimum width of the small toggle button
 * @cssproperty --dds-toggle-button-min-width-xs - Minimum width of the extra small toggle button
 * @cssproperty --dds-toggle-button-height-lg - Height of the large toggle button
 * @cssproperty --dds-toggle-button-height-md - Height of the medium toggle button
 * @cssproperty --dds-toggle-button-height-sm - Height of the small toggle button
 * @cssproperty --dds-toggle-button-height-xs - Height of the extra small toggle button
 * @cssproperty --dds-toggle-button-padding-lg - Padding of the large toggle button
 * @cssproperty --dds-toggle-button-padding-md - Padding of the medium toggle button
 * @cssproperty --dds-toggle-button-padding-sm - Padding of the small toggle button
 * @cssproperty --dds-toggle-button-padding-xs - Padding of the extra small toggle button
 * @cssproperty --dds-toggle-button-font-size-lg - Font size of the large toggle button
 * @cssproperty --dds-toggle-button-font-size-md - Font size of the medium toggle button
 * @cssproperty --dds-toggle-button-font-size-sm - Font size of the small toggle button
 * @cssproperty --dds-toggle-button-font-size-xs - Font size of the extra small toggle button
 * @cssproperty --dds-toggle-button-border-enabled - Border color in enabled state
 * @cssproperty --dds-toggle-button-background-enabled - Background color in enabled state
 * @cssproperty --dds-toggle-button-content-enabled - Content/text color in enabled state
 * @cssproperty --dds-toggle-button-border-hover - Border color in hover state
 * @cssproperty --dds-toggle-button-background-hover - Background color in hover state
 * @cssproperty --dds-toggle-button-border-pressed - Border color in pressed state
 * @cssproperty --dds-toggle-button-background-pressed - Background color in pressed state
 * @cssproperty --dds-toggle-button-background-selected-enabled - Background color in selected enabled state
 * @cssproperty --dds-toggle-button-content-selected-enabled - Content/text color in selected enabled state
 * @cssproperty --dds-toggle-button-background-selected-hover - Background color in selected hover state
 * @cssproperty --dds-toggle-button-background-selected-pressed - Background color in selected pressed state
 * @cssproperty --dds-toggle-button-border-disabled - Border color in disabled state
 * @cssproperty --dds-toggle-button-background-disabled - Background color in disabled state
 * @cssproperty --dds-toggle-button-content-disabled - Content/text color in disabled state
 * @cssproperty --dds-toggle-button-highcontrast-border - High contrast border color
 * @cssproperty --dds-toggle-button-highcontrast-border-hover - High contrast border color on hover
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSToggleButton',
})

export default reactWrapper
